import { Breakpoints, BreakpointsWithPx } from "../breakpoints";

(function (Drupal, drupalSettings) {
  // Expose breakpoints to scripts outside the webpack build (e.g. module JS).
  Drupal.breakpoints = Breakpoints;

  Drupal.isDarkMode = () => window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

  // Proof point links
  Drupal.behaviors.proofPointLinks = {
    attach: function attach(context) {
      const isProofPointLink = (url) => new URL(url).origin === location.origin && url.indexOf('/proof-point/') != -1;

      context.querySelectorAll('.text-formatted a').forEach(link => {
        if (link.hasAttribute('href') && isProofPointLink(link.href)) {
          link.classList.add('help-link');
          link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            link.setAttribute('disabled', true);

            // Get page dynamically, pop into modal.
            fetch(link.href)
              .then(res => res.text())
              .then(res => {
                const parser = new DOMParser()
                const doc = parser.parseFromString(res, "text/html");


                window.Alpine.store('modalContent',
                  doc.querySelector('.node--type-proof-point').innerHTML,
                );
                window.Alpine.store('modalOpen', true);

                link.removeAttribute('disabled');
              })
          });
        }
      });
    }
  };

  // Give links external setup
  Drupal.behaviors.externalLinks = {
    attach: function attach(context) {
      const isExternalURL = (url) => new URL(url).origin !== location.origin && url.indexOf('tel:') == -1 && url.indexOf('mailto:') == -1;
      context.querySelectorAll('.text-formatted a').forEach(link => {
        if (link.hasAttribute('href') && isExternalURL(link.href)) {
          link.classList.add('external');
          link.setAttribute('target','_blank');
        }
      });

      context.querySelectorAll('a:not([href^="https://recruiting.ultipro.ca/"]):not([href^="https://westfraser.mediaroom.com/"])').forEach(link => {
        if (link.hasAttribute('href') && isExternalURL(link.href)) {
          link.classList.add('ext');
          link.setAttribute('target','_blank');

          // Store original href and prevent default navigation
          if (!link.hasAttribute('data-original-href')) {
            link.setAttribute('data-original-href', link.href);
            link.addEventListener('click', function(event) {
              // Only prevent if we're showing confirmation
              if (typeof tippy !== 'undefined') {
                event.preventDefault();
              }
            });
          }
        }
      });

      // Check if tippy is available
      if (typeof tippy === 'undefined') {
        console.warn('Tippy.js is not loaded. External link tooltips will not be initialized.');
        return;
      }

      // Add tooltips to links with the "ext" class
      const extLinks = context.querySelectorAll('a.ext:not([data-tippy-initialized])');
      if (extLinks.length) {
        extLinks.forEach(link => {
          const originalHref = link.getAttribute('href');
          const domain = new URL(originalHref).hostname;

          // Mark as initialized to prevent duplicate tippy instances
          link.setAttribute('data-tippy-initialized', 'true');

          tippy(link, {
            content: `
              <div class="external-link-confirmation">
                <h2 class="flex gap-2 items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"/></svg>
                ${Drupal.t('You are leaving our website')}
                </h2>
                <p>${Drupal.t('You are leaving our site and we cannot be held responsible for the content of external websites.')}</p>
                <div class="external-link-actions mt-2 flex justify-end gap-2">
                  <button class="btn-cancel button-ghost-onlight-small">${Drupal.t('Stay here')}</button>
                  <button class="btn-proceed button-default-small">${Drupal.t('Continue')}</button>
                </div>
              </div>
            `,
            allowHTML: true,
            interactive: true,
            theme: 'light',
            trigger: 'click',
            placement: 'top',
            arrow: true,
            onShow(instance) {
              // Find buttons in the tooltip
              const tooltip = instance.popper;
              const cancelBtn = tooltip.querySelector('.btn-cancel');
              const proceedBtn = tooltip.querySelector('.btn-proceed');

              // Add click handlers
              cancelBtn.addEventListener('click', () => {
                instance.hide();
              });

              proceedBtn.addEventListener('click', () => {
                window.open(originalHref, '_blank');
                instance.hide();
              });
            }
          });
        });
      }
    }
  };

  // Handle disclaimer links with tooltips
  Drupal.behaviors.disclaimerLinks = {
    attach: function attach(context) {
      // Check if we have disclaimer settings and tippy is available
      if (!drupalSettings.wfContent || !drupalSettings.wfContent.disclaimer || typeof tippy === 'undefined') {
        return;
      }

      // Find all links with data-disclaimer attribute directly on them
      const directDisclaimerLinks = context.querySelectorAll('a[data-disclaimer]:not([data-disclaimer-initialized])');

      // Find all link elements inside elements with data-disclaimer="1"
      const disclaimerContainers = context.querySelectorAll('[data-disclaimer="1"]');

      // Process links with direct data-disclaimer attribute
      if (directDisclaimerLinks.length) {
        directDisclaimerLinks.forEach(link => {
          addDisclaimerTooltip(link);
        });
      }

      // Process links inside disclaimer containers
      if (disclaimerContainers.length) {
        disclaimerContainers.forEach(container => {
          const links = container.querySelectorAll('a:not([data-disclaimer-initialized])');
          links.forEach(link => {
            addDisclaimerTooltip(link);
          });
        });
      }

      // Helper function to add tooltip to links
      function addDisclaimerTooltip(link) {
        // Mark as initialized to prevent duplicate instances
        link.setAttribute('data-disclaimer-initialized', 'true');

        // Store original href
        if (!link.hasAttribute('data-original-href')) {
          link.setAttribute('data-original-href', link.href);

          // Add click event listener to prevent default navigation
          link.addEventListener('click', function(event) {
            event.preventDefault();
          });
        }

        tippy(link, {
          content: `
            <div class="disclaimer-link-confirmation">
              <h2 class="flex gap-2 items-center">${drupalSettings.wfContent.disclaimer.title || Drupal.t('Disclaimer')}</h2>
              ${drupalSettings.wfContent.disclaimer.text || ''}
              <div class="disclaimer-link-actions mt-2 flex justify-end gap-2">
                <button class="btn-cancel button-ghost-onlight-small">${Drupal.t('Cancel')}</button>
                <button class="btn-proceed button-default-small">${Drupal.t('Continue')}</button>
              </div>
            </div>
          `,
          allowHTML: true,
          interactive: true,
          theme: 'light',
          trigger: 'click',
          placement: 'top',
          arrow: true,
          // Append to body so the popover escapes the mega-menu's overflow:hidden
          // container; otherwise it gets clipped and hidden under the header. See #1802.
          appendTo: () => document.body,
          onShow(instance) {
            // Find buttons in the tooltip
            const tooltip = instance.popper;
            const cancelBtn = tooltip.querySelector('.btn-cancel');
            const proceedBtn = tooltip.querySelector('.btn-proceed');
            const originalHref = link.getAttribute('data-original-href');

            // Add click handlers
            cancelBtn.addEventListener('click', () => {
              instance.hide();
            });

            proceedBtn.addEventListener('click', () => {
              // Check if it's an external link that should open in a new tab
              if (link.classList.contains('ext') || link.classList.contains('external') || link.getAttribute('target') === '_blank') {
                window.open(originalHref, '_blank');
              } else {
                window.location.href = originalHref;
              }
              instance.hide();
            });
          }
        });
      }
    }
  };

  Drupal.behaviors.anchorsScrollTo = {
    attach: function (context) {
      context
        .querySelectorAll('a[href^="#"]:not([data-toggle="tab"]):not(.entity-browser-iframe)')
        .forEach((link) => link.addEventListener((event) => {
        if (link.hash !== "" && link.hash !== "#") {
          event.preventDefault();
          var hash = link.hash;

          siteScrollTo(hash);
        }
      }));

      // For when loading a page with anchor.
      if (window.location.hash) {
        scroll(0, 0);
        setTimeout(function () { scroll(0, 0); }, 1); // void some browsers issue

        // Run on load
        document.addEventListener('DOMContentLoaded', () => {
          siteScrollTo(window.location.hash);
        });
      }
    }
  };

  function siteScrollTo(hash) {
    // Support for Drupal admin toolbar.
    var positionTop = document.querySelector(window.location.hash).offsetTop;
    if (window.matchMedia(`(min-width: ${BreakpointsWithPx.md})`).matches) {
      var positionTop = positionTop - getSiteHeaderHeight();
    }

    window.scrollTo({
      top: positionTop,
      behavior: "smooth",
    });
  }

  Drupal.behaviors.anchorsScrollTo = {
    attach: function (context) {

      // Add class to body to make sure we didn't add it multiple times
      if (document.body.classList.contains('anchor-scroll')) {
        return;
      }
      document.body.classList.add('anchor-scroll');

      // Find all anchor links that don't have specific attributes
      const anchors = context.querySelectorAll('a[href^="#"]:not([data-toggle="tab"]):not(.entity-browser-iframe)');

      anchors.forEach(function(anchor) {
        anchor.addEventListener('click', function(event) {
          if (this.hash !== "" && this.hash !== "#") {
            event.preventDefault();
            siteScrollTo(this.hash);
          }
        });
      });

      // Handle page load with anchor in URL
      if (window.location.hash) {
        window.scrollTo(0, 0);
        // Avoid browser scrolling issues
        setTimeout(function() {
          window.scrollTo(0, 0);

          // Wait for DOM to be fully loaded
          if (document.readyState === 'complete' || document.readyState === 'interactive') {
            siteScrollTo(window.location.hash);
          } else {
            document.addEventListener('DOMContentLoaded', function() {
              siteScrollTo(window.location.hash);
            });
          }
        }, 1);
      }
    }
  };

  function siteScrollTo(hash) {
    const targetElement = document.querySelector(hash);
    if (!targetElement) return;

    let positionTop;
    // If the the item has the anchor class and one of his parents has .block-inline-blockaccordion then we need to adjust the position
    if (targetElement.classList.contains('anchor') && targetElement.closest('.block-inline-blockaccordion')) {
      positionTop = targetElement.closest('.block-inline-blockaccordion').getBoundingClientRect().top + window.pageYOffset;
      // Wait for the listener to be attached
      targetElement.closest('.block-inline-blockaccordion').querySelector('.accordion-trigger').click();
    }
    else {
      // Calculate the position to scroll to
      positionTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
    }

    // Adjust for the header height
    positionTop -= getSiteHeaderHeight();

    // Smooth scroll to element
    window.scrollTo({
      top: positionTop,
      behavior: 'smooth'
    });
  }

  function getSiteHeaderHeight() {
    const toolbarHeight = document.querySelector('#toolbar-bar') ? document.querySelector('#toolbar-bar').offsetHeight : 0;
    const toolbarTrayHeight = document.querySelector('#toolbar-item-administration-tray.toolbar-tray-horizontal') ? document.querySelector('#toolbar-item-administration-tray.toolbar-tray-horizontal').offsetHeight : 0;
    const secondaryToolbar = document.querySelector('.gin-secondary-toolbar') ? document.querySelector('.gin-secondary-toolbar').offsetHeight : 0;

    const headerHeight = document.querySelector('#header') ? document.querySelector('#header').offsetHeight : 0;

    // The sticky header section (Section tabs block) pins below the site header,
    // so anchored targets must clear it too.
    const stickyHeader = document.querySelector('.js-sticky-header');
    const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 0;

    return headerHeight + toolbarHeight + toolbarTrayHeight + secondaryToolbar + stickyHeaderHeight;
  }

    // Move Resources View Sort filter
  Drupal.behaviors.moveResourcesSort = {
    attach: function attach(context) {
      // Use context to ensure we are targeting the correct elements during AJAX updates
      let views = [];

      // If context is the document or a wrapper
      if (context.querySelectorAll) {
        views = Array.from(context.querySelectorAll('.view-id-resources.view-display-id-block_1'));
      }

      // If context is the view itself (which can happen during AJAX replacement)
      if (context.classList && context.classList.contains('view-id-resources') && context.classList.contains('view-display-id-block_1')) {
        views.push(context);
      }

      views.forEach(view => {
        const originalSortWrapper = view.querySelector('.views-exposed-form .form-item-sort-bef-combine');
        const sortTarget = view.querySelector('.view-sort');

        // Check if we have the elements
        if (originalSortWrapper && sortTarget) {
          // If the target is not empty, we assume it's already processed.
          if (sortTarget.children.length > 0) return;

          // Clone the wrapper instead of moving it
          // This ensures the original form element remains in place for Drupal's AJAX processing
          const clone = originalSortWrapper.cloneNode(true);

          // Hide the original wrapper so it's not visible but still functions
          originalSortWrapper.style.display = 'none';
          originalSortWrapper.setAttribute('aria-hidden', 'true');

          // Append the clone to the target location
          sortTarget.appendChild(clone);

          // Sync changes from the clone to the original
          // When the user interacts with the clone, we update the original and trigger its change event
          const cloneInputs = clone.querySelectorAll('select, input, textarea');
          const originalInputs = originalSortWrapper.querySelectorAll('select, input, textarea');

          cloneInputs.forEach((cloneInput, index) => {
             const originalInput = originalInputs[index];
             if (!originalInput) return;

             // Remove any duplicate IDs from the clone to avoid accessibility/JS conflicts
             // (Optional but good practice, though Alpine might rely on structure)
             // For now we keep them to ensure styles/scripts matching IDs still work,
             // but we must be aware of potential ID conflicts.

             // Attach change listener to clone
             // We use standard JS event listener here
             cloneInput.addEventListener('change', function() {
                // Update original value
                originalInput.value = cloneInput.value;

                // Trigger change on original to fire Drupal AJAX
                // We use jQuery if available to ensure it hooks into Drupal's event system
                if (window.jQuery) {
                   window.jQuery(originalInput).trigger('change');
                } else {
                   originalInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
             });
          });
        }
      });
    }
  };

  // Add data-label attributes to stacked tables for responsive display
  Drupal.behaviors.stackedTables = {
    attach: function attach(context) {
      context.querySelectorAll('table.table-stacked:not([data-stacked-initialized])').forEach(table => {
        // Mark as initialized
        table.setAttribute('data-stacked-initialized', 'true');

        // Get all header cells
        const headers = [];
        table.querySelectorAll('thead th').forEach(th => {
          headers.push(th.textContent.trim());
        });

        // Add data-label to each cell based on its column
        table.querySelectorAll('tbody tr').forEach(row => {
          row.querySelectorAll('td').forEach((cell, index) => {
            if (headers[index]) {
              cell.setAttribute('data-label', headers[index]);
            }
          });
        });
      });
    }
  };

}(Drupal, drupalSettings));

